/* BG COM 04/10/2026 (vitesse) : sorti tel quel de sections/bgcom-pdp-polish.liquid (couche de mouvement) (bloc <script> en ligne), chargé en defer. */
/* ══ motion layer (spec bgcom-motion, 29/09): gallery zoom cursor, configurator pill glide, pack check pop on choice,
   add-to-cart busy state, stock sonar gate, sticky card under reduced motion. The runtime (window.BGM) comes from
   snippets/bgcom-motion.liquid; work is queued on window.BGMq, so load order never matters (without the runtime only
   the glide and the gate are skipped). Nothing here stops or cancels an event. ══ */
(function(){
  var W = window, D = document;
  function mq(q){ try{ return !!(W.matchMedia && W.matchMedia(q).matches); }catch(_){ return false; } }
  function ready(fn){
    var go = function(){ try{ fn(); }catch(_){} };
    if(D.readyState === 'loading') D.addEventListener('DOMContentLoaded', go); else go();
  }

  /* gallery expand cursor (nextsense, its two bugs fixed): mouse + motion allowed only, never created on touch.
     The disc follows 1:1 with the translate property (rAF), pops in with a separate scale; the native cursor
     is hidden over the main-image zoom button alone (thumbnails, arrows, fiches keep it); a click hides it. */
  ready(function(){
    if(!mq('(hover: hover) and (pointer: fine)') || mq('(prefers-reduced-motion: reduce)')) return;
    var gal = D.querySelector('.featured-product media-gallery');
    if(!gal || D.querySelector('.bgm-zoomcur')) return;
    var c = D.createElement('div');
    c.className = 'bgm-zoomcur'; c.setAttribute('aria-hidden', 'true');
    var NS = 'http://www.w3.org/2000/svg', svg = D.createElementNS(NS, 'svg'), pth = D.createElementNS(NS, 'path');
    var attrs = [ ['viewBox', '0 0 24 24'], ['fill', 'none'], ['stroke', 'currentColor'], ['stroke-width', '2.2'], ['stroke-linecap', 'round'], ['stroke-linejoin', 'round'] ];
    attrs.forEach(function(a){ svg.setAttribute(a[0], a[1]); });
    pth.setAttribute('d', 'M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7'); svg.appendChild(pth); c.appendChild(svg);
    D.body.appendChild(c);
    D.documentElement.classList.add('bgm-zc');
    var wide = W.matchMedia('(min-width: 1024px)');   /* under 1024px the zoom button is the small round icon, not the image */
    var x = 0, y = 0, raf = 0, shown = false;
    function paint(){ raf = 0; c.style.translate = (x - 28) + 'px ' + (y - 28) + 'px'; }
    function set(v){ if(v !== shown){ shown = v; c.classList.toggle('is-on', v); } }
    gal.addEventListener('pointermove', function(e){
      if(e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      var on = wide.matches && !!(e.target && e.target.closest && e.target.closest('button[is=media-lightbox-button]'));
      if(on && !shown){ if(raf) cancelAnimationFrame(raf); paint(); }   /* appear where the pointer is, not where it left */
      else if(!raf) raf = requestAnimationFrame(paint);
      set(on);
    }, { passive:true });
    gal.addEventListener('pointerleave', function(){ set(false); });
    gal.addEventListener('click', function(){ set(false); });   /* PhotoSwipe opens on top */
  });

  /* configurator pills ASPECT / BRILLANCE (dropship segmented glide): a 7% ink pill glides between hovered pills,
     FLIP on the runtime's system (200ms, out-curve), mouse + fine pointer only, fades on leave; the delegated listener
     survives theme re-renders */
  (W.BGMq = W.BGMq || []).push(function(M){
    M.glide('.bgcom-product-configurator__radiogroup', 'label.bgcom-product-configurator__radio', { px:4, py:4, radius:10, color:'rgba(23,23,23,.07)', dur:200 });
  });

  /* Conditionnement check glyph (dropship pricing-badge pop): click feedback on a small glyph, so the one place the
     motion system allows the spring (jury D9). Tied to the buyer's action, not to the :checked state. A 'change' on a
     pack radio pops the glyph of the card just chosen, once (.5 -> 1 with a fade, 200ms on --bgm-spring, as BGM.pop;
     the fade simply reaches 1 early), and only if the buyer pressed a pointer or a key inside the pack cards in the
     last 1.5s (click, tap, arrow key). Nothing pops at page load, when the theme swaps the variant picker after its
     fetch (the new nodes fire no 'change'), or when a script ticks a radio (radio.click() fires a trusted 'change',
     hence the intent stamp). Only the glyph animates; the card never moves. Skipped under reduced motion.
     Listens only, never cancels. */
  if(!W.__bgmPackPop){
    W.__bgmPackPop = 1;
    var packIntent = 0;
    var stampIntent = function(e){ try{ if(e.isTrusted && e.target && e.target.closest && e.target.closest('.bgcom-packs')) packIntent = Date.now(); }catch(_){} };
    D.addEventListener('pointerdown', stampIntent, true);
    D.addEventListener('keydown', stampIntent, true);
    D.addEventListener('change', function(e){
      try{
        var r = e.target;
        if(!e.isTrusted || !r || !r.checked || !r.matches || !r.matches('.product__info .bgcom-pack__radio')) return;
        if(Date.now() - packIntent > 1500 || mq('(prefers-reduced-motion: reduce)')) return;
        var lab = r.nextElementSibling, svg = lab && lab.querySelector('.bgcom-pack__check svg');
        if(!svg || !svg.animate) return;
        svg.animate([ { scale:'.5', opacity:0 }, { scale:'1', opacity:1 } ], { duration:200, easing:'cubic-bezier(.34,1.56,.64,1)' });
      }catch(_){}
    }, true);
  }

  /* add-to-cart busy state (nextsense): window capture runs before the Fly interceptor (document capture) and only
     listens. The pressed button gets aria-busy + a spinner until #bgpro-overlay opens (+250ms) or 4s at most.
     A RAL field failing native validation fires no submit, so no spinner. */
  function clearBusy(b){ b.classList.remove('bgm-busy'); b.removeAttribute('aria-busy'); }
  if(!W.__bgmBusyWired){
    W.__bgmBusyWired = 1;
    W.addEventListener('submit', function(e){
      try{
        var f = e.target;
        if(!f || f.tagName !== 'FORM') return;
        /* read the id attribute: on a product form, f.id is clobbered by the variant <input name="id"> */
        var fid = f.getAttribute('id') || '';
        if((f.getAttribute('action') || '').indexOf('/cart/add') < 0 || fid.indexOf('ProductForm-') !== 0) return;
        var sub = e.submitter, sel = (W.CSS && CSS.escape) ? CSS.escape(fid) : fid;
        var b = (sub && sub.matches && sub.matches('.product-form__submit, product-sticky-form button[type=submit]')) ? sub : D.querySelector('.product-form__submit[form=' + sel + ']');
        if(!b || b.classList.contains('bgm-busy')) return;
        var ov = D.getElementById('bgpro-overlay'), mo = null, t = 0;
        var done = function(){ clearTimeout(t); if(mo) mo.disconnect(); clearBusy(b); };
        b.classList.add('bgm-busy'); b.setAttribute('aria-busy', 'true');
        t = setTimeout(done, 4000);
        if(ov && 'MutationObserver' in W){
          mo = new MutationObserver(function(){ if(ov.classList.contains('is-open')){ mo.disconnect(); setTimeout(done, 250); } });
          mo.observe(ov, { attributes:true, attributeFilter:['class'] });
        }
      }catch(_){}
    }, true);
    /* back/forward cache: never come back to a frozen button */
    W.addEventListener('pageshow', function(e){ if(e.persisted) [].forEach.call(D.querySelectorAll('.bgm-busy'), clearBusy); });
  }

  /* stock sonar: paused while the buy box is more than 200px off screen (runtime gate, animation-play-state only) */
  (W.BGMq = W.BGMq || []).push(function(M){ M.gate('.product__info'); });

  /* sticky buy card: the theme's Motion show/hide ignores reduced motion; under reduce, jump to its end state */
  ready(function(){
    var rm = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)');
    var el = D.querySelector('product-sticky-form');
    if(!rm || !el || !el.getAnimations || !('MutationObserver' in W) || el.__bgmRm) return;
    el.__bgmRm = 1;
    function finish(){ if(!rm.matches) return; el.getAnimations({ subtree:true }).forEach(function(a){ try{ a.finish(); }catch(_){} }); }
    new MutationObserver(finish).observe(el, { attributes:true, attributeFilter:['style', 'class'], subtree:true });
  });
})();
